import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tickets from './pages/Tickets';
import TicketDetail from './pages/TicketDetail';
import NewTicket from './pages/NewTicket';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import Devices from './pages/Devices';
import DeviceDetail from './pages/DeviceDetail';
import MagicLinkTicket from './pages/MagicLinkTicket';
import JournalMagicEntry from './pages/JournalMagicEntry';
import Suppliers from './pages/Suppliers';
import SupplierDetail from './pages/SupplierDetail';
import Settings from './pages/Settings';
import MailInbox from './pages/MailInbox';
import ServiceReports from './pages/ServiceReports';
import DRReports from './pages/DRReports';
import DRReportForm from './pages/DRReportForm';
import DRReportDetail from './pages/DRReportDetail';
import TicketSummaryPreview from './pages/TicketSummaryPreview';
import JournalPage from './pages/JournalPage';
import TotpVerify from './pages/TotpVerify';
import SetupTwoFactor from './pages/SetupTwoFactor';
import Users from './pages/Users';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-500 text-sm">Laden...</div>;
  return user ? <Layout>{children}</Layout> : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/tickets" element={<PrivateRoute><Tickets /></PrivateRoute>} />
          <Route path="/tickets/new" element={<PrivateRoute><NewTicket /></PrivateRoute>} />
          <Route path="/tickets/:id" element={<PrivateRoute><TicketDetail /></PrivateRoute>} />
          <Route path="/customers" element={<PrivateRoute><Customers /></PrivateRoute>} />
          <Route path="/customers/:id" element={<PrivateRoute><CustomerDetail /></PrivateRoute>} />
          <Route path="/devices" element={<PrivateRoute><Devices /></PrivateRoute>} />
          <Route path="/devices/:id" element={<PrivateRoute><DeviceDetail /></PrivateRoute>} />
          <Route path="/ticket/:token" element={<MagicLinkTicket />} />
          <Route path="/journal-entry/:token" element={<JournalMagicEntry />} />
          <Route path='/suppliers' element={<PrivateRoute><Suppliers /></PrivateRoute>} />
          <Route path='/suppliers/:id' element={<PrivateRoute><SupplierDetail /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
          <Route path="/mail" element={<PrivateRoute><MailInbox /></PrivateRoute>} />
          <Route path="/serviceberichte" element={<PrivateRoute><ServiceReports /></PrivateRoute>} />
          <Route path="/dr-reports" element={<PrivateRoute><DRReports /></PrivateRoute>} />
          <Route path="/dr-reports/new" element={<PrivateRoute><DRReportForm /></PrivateRoute>} />
          <Route path="/dr-reports/:id" element={<PrivateRoute><DRReportDetail /></PrivateRoute>} />
          <Route path="/dr-reports/:id/edit" element={<PrivateRoute><DRReportForm /></PrivateRoute>} />
          <Route path="/tickets/:id/summary-preview" element={<PrivateRoute><TicketSummaryPreview /></PrivateRoute>} />
          <Route path="/journal" element={<PrivateRoute><JournalPage /></PrivateRoute>} />
          <Route path="/totp-verify" element={<TotpVerify />} />
          <Route path="/setup-2fa" element={<SetupTwoFactor />} />
          <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
